import Radium from "radium";
import { connect } from "react-redux";

import Devices, { IDevicesActions, IDevicesProps } from "./devices";
import { getDevices, removeDevice } from "../user.actions";
import { IUserSate } from "../user.reducer";

export default connect(
  ({ user }: { user: IUserSate }): IDevicesProps => {
    const { devices, userId } = user;
    return {
      devices,
      userId
    };
  },
  (dispatch): IDevicesActions => {
    return {
      refreshDevices: () => dispatch(getDevices()),
      removeDevice: (userId: string, deviceId: string) =>
        dispatch(removeDevice(userId, deviceId))
    };
  }
)(Radium(Devices));
